<app-expandable-section
  [title]="'DEAD_LETTERS.DETAIL.SECTIONS.DELIVERY_DIAGNOSTICS' | translate"
  [(expanded)]="expanded"
  (expandedChange)="expandedChange.emit($event)">
  <div class="metadata-grid">
    <div class="metadata-item">
      <span class="label">{{ 'DEAD_LETTERS.DETAIL.FIELDS.REASON' | translate }}</span>
      <span class="value">{{ detail.deadLetterReason }}</span>
    </div>

    <div class="metadata-item">
      <span class="label">{{ 'DEAD_LETTERS.DETAIL.FIELDS.DELIVERY_ATTEMPTS' | translate }}</span>
      <span class="value">{{ detail.deliveryAttempts }}</span>
    </div>

    <div class="metadata-item">
      <span class="label">{{ 'DEAD_LETTERS.DETAIL.FIELDS.LAST_DELIVERY_OUTCOME' | translate }}</span>
      <span class="value">{{ detail.lastDeliveryOutcome }}</span>
    </div>

    <div class="metadata-item">
      <span class="label">{{ 'DEAD_LETTERS.DETAIL.FIELDS.LAST_HTTP_STATUS_CODE' | translate }}</span>
      <span class="value">
        {{ detail.lastHttpStatusCode ?? ('DEAD_LETTERS.DETAIL.VALUES.NOT_AVAILABLE' | translate) }}
      </span>
    </div>

    <div class="metadata-item">
      <span class="label">{{ 'DEAD_LETTERS.DETAIL.FIELDS.PUBLISH_TIME' | translate }}</span>
      <span class="value value-copyable" [matTooltip]="detail.publishTime">{{ detail.publishTime | date:'medium' }}</span>
    </div>

    <div class="metadata-item">
      <span class="label">{{ 'DEAD_LETTERS.DETAIL.FIELDS.LAST_DELIVERY_ATTEMPT_TIME' | translate }}</span>
      <span class="value value-copyable" [matTooltip]="detail.lastDeliveryAttemptTime">{{ detail.lastDeliveryAttemptTime | date:'medium' }}</span>
    </div>
  </div>
</app-expandable-section>
